export function documentSourceDomain(sourceUrl: string | null): string {
  if (!sourceUrl) return "No source URL";
  try {
    return new URL(sourceUrl).hostname.replace(/^www\./, "");
  } catch {
    return "Unknown source";
  }
}
